import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import CampaignService from 'donor-elf-web/services/campaign-service';

export default class CampaignsEnabledHelper extends Helper {
  @service declare campaignService: CampaignService;

  compute(/* positionalArgs, namedArgs*/) {
    return this.campaignService.campaignsEnabled;
  }
}
